import { createSvgIcon } from '@mui/material';

export const GCashIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19685_71127)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#E7EBFA'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M22.8691 8.48956C23.8193 8.17913 24.8301 8.05042 25.8295 8.11478C27.2946 8.19428 28.7256 8.71292 29.9181 9.56471C30.0469 9.65935 30.1869 9.74643 30.2967 9.86757C30.486 10.0834 30.5617 10.39 30.4936 10.6701C30.4254 10.973 30.1869 11.2304 29.8916 11.3213C29.6039 11.4121 29.2746 11.3516 29.0436 11.1585C28.154 10.4733 27.0713 10.0417 25.9545 9.93571C25.5456 9.89028 25.1292 9.89028 24.7203 9.93571C23.543 10.0531 22.4035 10.5263 21.4873 11.2796C20.4538 12.1239 19.7004 13.3126 19.4052 14.6149C19.1326 15.796 19.2159 17.0605 19.655 18.1924C20.1169 19.3963 20.9762 20.4373 22.059 21.1339C22.8691 21.6526 23.8042 21.9743 24.7582 22.0652C25.1292 22.1106 25.5078 22.1106 25.875 22.069C27.0296 21.9706 28.1464 21.5276 29.0626 20.8197C29.2935 20.638 29.6229 20.585 29.903 20.6796C30.2891 20.8121 30.5655 21.2248 30.5163 21.6336C30.4936 21.8721 30.3686 22.0993 30.1794 22.2431C29.4525 22.811 28.6272 23.2464 27.7489 23.5265C26.617 23.8899 25.398 23.9846 24.2206 23.8218C22.9145 23.6401 21.6577 23.1176 20.6052 22.3226C19.5831 21.5579 18.7502 20.5396 18.2013 19.3849C17.6637 18.253 17.4025 16.9885 17.4479 15.7355C17.4896 14.1947 18.0006 12.6728 18.9017 11.4197C19.8708 10.0569 21.2753 9.00821 22.8691 8.48956Z'
        fill='#007CFF'
        stroke='#007CFF'
        strokeWidth='0.00354913'
      />
      <path
        opacity='0.4'
        d='M24.7202 9.93593C25.1291 9.8905 25.5455 9.8905 25.9544 9.93593C25.5417 9.92457 25.1329 9.92457 24.7202 9.93593Z'
        fill='#001934'
        stroke='#001934'
        strokeWidth='0.00354913'
      />
      <path
        d='M33.9467 10.64C34.3404 10.5226 34.8022 10.7081 34.9915 11.0791C35.9001 12.8546 36.2976 14.8838 36.1348 16.8713C36.0212 18.2872 35.6313 19.6841 34.9764 20.9448C34.7379 21.3953 34.0981 21.5391 33.6854 21.2438C33.3031 20.9978 33.1782 20.4488 33.4053 20.0513C34.6697 17.5679 34.6811 14.4901 33.4318 11.9991C33.3182 11.7946 33.2577 11.5524 33.3144 11.3214C33.3788 10.9996 33.6324 10.7271 33.9467 10.64Z'
        fill='#6FBAF7'
        stroke='#6FBAF7'
        strokeWidth='0.00354913'
      />
      <path
        d='M22.7476 11.7036C24.3528 10.7345 26.522 10.761 28.0817 11.8172C28.4679 12.1011 28.5474 12.7069 28.2483 13.0816C27.9795 13.4489 27.423 13.5586 27.0406 13.3126C26.4349 12.9264 25.7005 12.7599 24.9888 12.8431C24.277 12.9189 23.5956 13.2482 23.0959 13.7593C22.5962 14.2552 22.2706 14.9215 22.1911 15.6219C22.1192 16.1897 22.2138 16.7765 22.4485 17.2989C22.759 17.988 23.323 18.5596 24.012 18.8776C24.7162 19.2107 25.5415 19.2637 26.2835 19.0328C27.2753 18.73 28.0969 17.9085 28.3808 16.9128C27.6691 16.9166 26.9573 16.9128 26.2456 16.9128C25.9049 16.9128 25.5756 16.7008 25.4355 16.3942C25.2613 16.0421 25.3522 15.584 25.6475 15.3266C25.7989 15.1903 25.9996 15.0994 26.204 15.0919C27.2791 15.0843 28.3505 15.0881 29.4256 15.0881C29.7777 15.0767 30.1184 15.2963 30.2585 15.6181C30.3796 15.8679 30.3418 16.1519 30.3266 16.4207C30.232 17.5867 29.7058 18.711 28.8729 19.5363C28.0741 20.3389 26.9952 20.8575 25.8671 20.9711C24.7578 21.0923 23.6108 20.8235 22.6681 20.2215C21.7179 19.6196 20.9759 18.6845 20.6125 17.617C20.2415 16.538 20.2604 15.3304 20.6465 14.259C21.0251 13.199 21.7822 12.2829 22.7476 11.7036Z'
        fill='#002CB8'
        stroke='#002CB8'
        strokeWidth='0.00354913'
      />
      <path
        d='M31.4852 12.199C31.8751 12.0968 32.318 12.2974 32.4998 12.657C33.484 14.7392 33.484 17.2605 32.4998 19.3427C32.3748 19.5887 32.125 19.7704 31.8486 19.8159C31.5268 19.8727 31.1823 19.7364 30.9817 19.4789C30.7735 19.2102 30.7356 18.824 30.887 18.5211C31.6215 16.9274 31.6101 15.0156 30.8681 13.4256C30.6447 12.9372 30.9627 12.3125 31.4852 12.199Z'
        fill='#6FBAF7'
        stroke='#6FBAF7'
        strokeWidth='0.00354913'
      />
      <path
        opacity='0.46'
        d='M24.7578 22.0645C25.1326 22.072 25.5036 22.072 25.8746 22.0682C25.5074 22.1099 25.1288 22.1099 24.7578 22.0645Z'
        fill='#001E3E'
        stroke='#001E3E'
        strokeWidth='0.00354913'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19685_71127'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19685_71127'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19685_71127'
          result='effect2_dropShadow_19685_71127'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19685_71127'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'GCashIcon',
);
